import { createSlice } from "@reduxjs/toolkit/"

let initialState = {
    quizzprofileList : [],
    selectedQuizzProfile:{},
}
const quizzProfileSlice = createSlice({
    name:'quizzprofile',
    initialState,
    reducers:{
        setQuizzProfileList:(state,{payload})=>{
            state.quizzprofileList = payload
        },
        setSelectedQuizzProfile:(state,{payload})=>{
            state.selectedQuizzProfile = payload
        },
    }
})

export const { setQuizzProfileList,setSelectedQuizzProfile} = quizzProfileSlice.actions
export default quizzProfileSlice.reducer